export const CATEGORY_LABELS = {
  cars: "Voitures",
  yachts: "Yachts",
  properties: "Villas & Appartements",
};

export const CATEGORY_BADGE = {
  cars: "VOITURE DE LUXE",
  yachts: "SUPER YACHT",
  properties: "VILLA PRESTIGE",
};

export const PRICE_UNIT_LABELS = {
  day: "/ jour",
  night: "/ nuit",
  week: "/ semaine",
  request: "sur demande",
};

export function formatPrice(value, unit) {
  if (unit === "request" || !value || value <= 0) return "Sur demande";
  const formatted = new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(value || 0);
  return `${formatted} ${PRICE_UNIT_LABELS[unit] || "/ jour"}`;
}

export const STATUS_LABELS = {
  nouveau: "Nouveau",
  en_cours: "En cours",
  confirme: "Confirmé",
  annule: "Annulé",
};

export const SPEC_LABELS = {
  brand: "Marque",
  model: "Modèle",
  year: "Année",
  power: "Puissance",
  seats: "Places",
  transmission: "Transmission",
  engine: "Moteur",
  torque: "Couple",
  acceleration: "0-100 km/h",
  topSpeed: "Vitesse max",
  drivetrain: "Transmission",
  fuelType: "Carburant",
  kmIncluded: "Km inclus",
  deposit: "Caution (€)",
  monthlyPrice: "Prix / mois (€)",
  carCategory: "Catégorie",
  length: "Longueur",
  capacity: "Capacité",
  cabins: "Cabines",
  crew: "Équipage",
  port: "Port d'attache",
  features: "Caractéristiques",
  builder: "Chantier naval",
  guests: "Invités",
  berths: "Couchages",
  beam: "Largeur",
  cruisingSpeed: "Vitesse de croisière",
  city: "Ville",
  travelers: "Voyageurs",
  bedrooms: "Chambres",
  bathrooms: "Salles de bains",
  surface: "Surface",
  amenities: "Équipements",
};

export const SPEC_FIELDS = {
  cars: ["brand", "model", "year", "power", "seats", "transmission", "engine", "torque", "acceleration", "topSpeed", "drivetrain", "fuelType", "kmIncluded", "deposit", "monthlyPrice", "carCategory"],
  yachts: ["builder", "length", "guests", "cabins", "crew", "berths", "beam", "cruisingSpeed", "port"],
  properties: ["city", "travelers", "bedrooms", "bathrooms", "surface", "amenities"],
};
